import { useEffect, useState } from 'react';
import { NavBar } from '../../../../../themes/components/Navbar';
import { Sidebar } from '../../../../../themes/components/Sidebar';
import { Toaster } from 'react-hot-toast';
import { FooterRelatorios } from '../../../components/FooterRelatorios';
import { VscRunAll } from 'react-icons/vsc';
import { AiOutlineClear } from 'react-icons/ai';
import { Button } from '../../../../../themes/components/Button';
import { useRelatorios } from '../../../../../contexts/Relatorios';
import ReactLoading from 'react-loading';
import { useHistory } from 'react-router-dom';
import { useModals } from '../../../../../contexts/Modals';
import { ContainerRelatorio } from '../../../components/VisualizarRelatorio';
import { FieldDropdown, FieldDropdownVer2 } from '../../../../../themes/components/FieldDropdown';
import { ArrayProdutos, Produto } from '../../../../pedidos/interfaces';
import { usePedidos } from '../../../../../contexts/Pedidos';

export const RVPE620 = () => {
    const history = useHistory();
    const { mostrarInfoOK } = useModals();
    const { filtrarProdutos } = usePedidos();
    const { loadingRelatorio, urls, setUrls, gerarRelatorio, setLoadingRelatorio } = useRelatorios();
    const [tipo, setTipo] = useState<{ cod: string, nome: string }>({ cod: "N", nome: "Normal" });
    const listaTipos = [{ cod: "N", nome: "Normal" }, { cod: "C", nome: "Corte" }]
    const [codAgrup, setCodAgrup] = useState<string>("");
    const [listaProdutos, setListaProdutos] = useState<ArrayProdutos>();
    const [loadingProdutos, setLoadingProdutos] = useState<boolean>(false);
    const [fieldProduto, setFieldProduto] = useState<string>("");

    const [estoque, setEstoque] = useState("GA");
    const [iEstoque, setIEstoque] = useState("2");
    const optEstoque = [
        { "cod": "2", "nome": "GA" },
        { "cod": "4", "nome": "AB" }
    ];
    const [codRelatorio, setCodRelatorio] = useState("");

    useEffect(() => {
        let cod = iEstoque == "2" ? "SECE500" : iEstoque == "4" ? "SECE504" : "SECE500";

        setUrls((prevState) => ({
            ...prevState,
            "RVPE620": ""
        }));
        // component unmount 
        return () => {
            setLoadingRelatorio((prevState) => ({
                ...prevState,
                "RVPE620": false
            }))
        }
    }, [iEstoque]);


    function handleChangeProduto(event: any, option: any, reason: any) {
        async function getProduto() {
            await filtrarProdutos(event.target.value, history)
                .then((res) => {
                    setListaProdutos(res);
                    setLoadingProdutos(false);
                })
                .catch((err) => {
                    if (err !== "Cancel") {
                        setListaProdutos([]);
                        setLoadingProdutos(false);
                    }
                })

        }

        if (reason === "input" && event !== null && event.target.value.trim() !== "") {
            if (fieldProduto !== "") {
                setFieldProduto("");
            }
            setLoadingProdutos(true);
            getProduto();
            setCodAgrup(event.target.value.trim());
        }

        if (reason === "reset" && option.trim() !== "") {
            let cod = new RegExp("[0-9]*", '').exec(option);
            if (cod !== null) {
                setFieldProduto(cod[0]);
            }
        }

        if (reason === "clear" || (event !== null && String(event.target.value).trim() === "")) {
            handleClearFields();
        }
    }

    function getOptionByCod(cod: string) {
        for (let index = 0; listaProdutos && index < listaProdutos.length; index++) {
            const element = listaProdutos[index];
            if (element.codclc === cod) {
                return element;
            }
        }
        return "";
    }

    const handleChangeTipo = (newInputValue: string) => {
        let campo = listaTipos.filter((item) => { return item.nome.toLowerCase() === newInputValue.toLowerCase() })[0]
        if (campo !== null && campo !== undefined)
            setTipo(campo);
    };

    function handleClearFields() {
        setCodAgrup("");
        setFieldProduto("");
        setTipo({ cod: "N", nome: "Normal" });
        setEstoque("GA");
        setIEstoque("2");
    }

    function solicitarRelatorio() {
        let cod = iEstoque == "2" ? "RVPE620" : iEstoque == "4" ? "RVPE621" : "RVPE620";
        let objParams: any = [];
        if (fieldProduto !== "") {
            objParams.push({ nome: "CODCLC", valor: fieldProduto })
        }
        if (codAgrup !== "") {
            objParams.push({ nome: "CODCLC", valor: codAgrup })
        }
        if (tipo.cod !== "") {
            objParams.push({ nome: "TABCRT", valor: tipo.cod })
        }

        if (objParams.length > 0) {
            setUrls((prevState) => ({
                ...prevState,
                cod: ""
            }));
            objParams.push({ nome: "CODEMP", valor: iEstoque });
            gerarRelatorio(cod, JSON.parse(JSON.stringify(objParams)), history);
            setCodRelatorio(cod);
        } else {
            objParams.push({ nome: "TABCRT", valor: tipo.cod });
            setUrls((prevState) => ({
                ...prevState,
                cod: ""
            }));
            objParams.push({ nome: "CODEMP", valor: iEstoque });
            gerarRelatorio(cod, JSON.parse(JSON.stringify(objParams)), history);
        }

    }

    function getEstoqueList() {
        let temp: string[] = []
        optEstoque.forEach((opt) => {
            temp.push(opt.nome)
        })
        return temp;
    }

    function getCodEstoque(text: string) {
        let sit = "";
        optEstoque.forEach((opt) => {
            if (opt.nome === text) {
                sit = opt.cod;
            }
        })
        return sit;
    }

    return (
        <div className="site">
            <Sidebar />
            <div className="main-content">
                <div className="main-content-relatorios">
                    <NavBar />
                    <span className="novo-pedido-title-form">Parâmetros do Relatório</span>
                    <div className="relatorios-campo-busca">
                        <form>
                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="consulta-combobox-tipo-pedido">Código do Agrupamento</label>
                                    <div className="pedido-linha-campo">
                                        <FieldDropdownVer2
                                            id="additens-combobox-searchproduto"
                                            options={listaProdutos || []}
                                            loading={loadingProdutos}
                                            value={getOptionByCod(fieldProduto)}
                                            select={(option: Produto, value: Produto) => option.codclc === value.codclc}
                                            label={(option: Produto) => option.codclc !== undefined ? option.codclc + " - " + option.nompro : ""}
                                            onChange={(event, option, reason) => handleChangeProduto(event, option, reason)}
                                            noOptionsText={"Digite um código ou nome válido"}
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="consulta-combobox-tipo-pedido">Tipo da Tabela</label>
                                    <div className="pedido-linha-campo">
                                        <FieldDropdown
                                            value={tipo.nome}
                                            id={"campo-tipo"}
                                            options={listaTipos.map((item) => { return item.nome })}
                                            label={(option: string) => option}
                                            onChange={(event, newInputValue) => {
                                                handleChangeTipo(newInputValue);
                                            }
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="form-group" >
                                    <label htmlFor="consulta-combobox-tipo-pedido">Empresa</label>
                                    <div className={""}>
                                        <FieldDropdown
                                            value={estoque}
                                            id="seleciona-combobox-estoque"
                                            options={getEstoqueList()}
                                            label={(option: string) => option}
                                            onChange={(event, newInputValue) => {
                                                setEstoque(newInputValue);
                                                setIEstoque(getCodEstoque(newInputValue));
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="form-buttons">
                                    <Button titleText="Gerar relatório" classBtn="" onClick={() => solicitarRelatorio()} >
                                        <VscRunAll color="#444" style={{ marginBottom: '0.3em' }} />
                                    </Button>
                                    <Button titleText="Limpar campos" classBtn="" onClick={() => handleClearFields()} >
                                        <AiOutlineClear color="#444" style={{ marginBottom: '0.3em' }} />
                                    </Button>
                                </div>
                            </div>
                        </form>
                    </div>

                    {codRelatorio &&

                        codRelatorio == "RVPE620" ?
                            loadingRelatorio.RVPE620 === true ?
                                <div className="loading-table-list-pedidos"><ReactLoading type={"bars"} color={"#0252a8"} height={30} width={50} /></div>
                                :
                                urls['RVPE620'] !== "" ?
                                    <ContainerRelatorio arquivoUrl={urls['RVPE620']} />
                                : <></>

                        :

                        codRelatorio == "RVPE621" ?
                            loadingRelatorio.RVPE621 === true ?
                                <div className="loading-table-list-pedidos"><ReactLoading type={"bars"} color={"#0252a8"} height={30} width={50} /></div>
                                :
                                urls['RVPE621'] !== "" ?
                                    <ContainerRelatorio arquivoUrl={urls['RVPE621']} />
                                : <></>

                        :
                        <></>
                    }
                </div>
                <FooterRelatorios funcGerar={() => solicitarRelatorio()} funcImprimir={() => { }} regraGerar={true} regraImprimir={false} />
            </div>
            <Toaster />
        </div>
    )
}
